import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

export const convertUTCtoMSK = (date = '', dateFormat = 'dd.MM.yyyy HH:mm'): string => {
  const moscowTime = utcToZonedTime(new Date(date), 'Europe/Moscow')
  const formattedMoscowTime = format(moscowTime, dateFormat)

  return formattedMoscowTime
}
